import { DEFAULT_LANGUAGE, ENABLE_DRESS_CODE } from './feature-flags';
/**
 * ************************************************
 * Time & Language Property
 * ************************************************
 */
import dayjs from 'dayjs';
import 'dayjs/locale/id';
import 'dayjs/locale/en';

/**
 * ************************************************
 * Flag to to set Bride to BOY first
 * ************************************************
 */
export const IS_BOY_FIRST = false;

/**
 * ************************************************
 * Bride & Groom Info
 * ************************************************
 */
export const GIRL_NAME = 'Sri Wahyu Murdaniasih, S.E';
export const GIRL_NAME_SHORT = 'Dania';
export const GIRL_FATHER_NAME = `Drs. H. Nusantara, M.M`;
export const GIRL_MOTHER_NAME = `Hj. Murnasih`;
export const GIRL_PARENT_NAME =
  DEFAULT_LANGUAGE === 'en'
    ? `The daughter of: <br />Mr. ${GIRL_FATHER_NAME}<br /> and Mrs. ${GIRL_MOTHER_NAME}`
    : `Putri dari:<br />Bapak ${GIRL_FATHER_NAME}<br /> dan Ibu ${GIRL_MOTHER_NAME}`;

// -> boy section
export const BOY_NAME = 'Hudan Majid Ibrahim, S.M';
export const BOY_NAME_SHORT = 'Dani';
export const BOY_FATHER_NAME = `Sadwoko Heri Susatyo, S.E., M.Si`;
export const BOY_MOTHER_NAME = `Putri Astuti Esti Utami`;
export const BOY_PARENT_NAME =
  DEFAULT_LANGUAGE === 'en'
    ? `The son of: <br />Mr. ${BOY_FATHER_NAME}<br />and Mrs. ${BOY_MOTHER_NAME}`
    : `Putra dari: <br />Bapak ${BOY_FATHER_NAME}<br />dan Ibu ${BOY_MOTHER_NAME}`;

// -> bride section
export const BRIDE_HASHTAG = ``;
export const THE_BRIDE = 'Patra Wedding Expo'
/**
 * ************************************************
 * Instagram Profile Account
 * @important please put instagram id without `@`
 * ************************************************
 */
export const IG_GIRL = 'daniasih';
export const IG_BOY = 'hudanibrahim_';
export const IG_FILTER_URL = `https://www.instagram.com/ar/1726677507686205`;

/**
 * ************************************************
 * SEO Requirement
 * @important - Don't forget to update SEO IMAGE
 * ************************************************
 */
export const SEO_IMAGE = `https://user-images.githubusercontent.com/106049860/180939238-df47e587-0f31-4c71-b76a-3cdad7da21ae.png`;
export const SEO_URL = 'https://invitato.net/';
export const SEO_TITLE = `The Wedding of ${THE_BRIDE} by Invitato`;
export const SEO_DESCRIPTION = `Patra Wedding Expo bertajuk Unforgettable Sweetness Moment adalah event yang sarat dengan edukasi dan sharing moment dari para vendor dan asosiasi untuk para calon mempelai pernikahan, dengan tujuan calon pengantin dapat mempersiapkan Upacara Pernikahan dengan maksimal dan menjadi moment kenangan termanis pada salah satu bagian terpenting dalam perjalanan hidup mereka.`
/**
 * ************************************************
 * Time requirement for Counting Down, and
 * Remind me generator
 * @important - please convert time to Epoch time by
 * using this link https://www.epochconverter.com/
 * ************************************************
 */
export const EPOCH_START_EVENT = 1659322800;
export const EPOCH_RESEPSI_START = 1659322800;
export const EPOCH_END_EVENT = 1659535200;

/**
 * ************************************************
 * DATE REQUIREMENT
 * @important - Format date YYYY-MM-DD
 * ************************************************
 */
export const DATE_AKAD = new Date('2022-07-16');
export const DATE_RESEPSI = new Date('2022-07-16');

export const WEDDING_AKAD_TIME = '08.00 WIB - 10.00 WIB';
export const WEDDING_AKAD_LOC_NAME = 'Gets Hotel Semarang';
export const WEDDING_AKAD_LOC_ROAD = `Jl. MT. Haryono No.312 - 316, Sarirejo, Kec. Semarang Timur, Kota Semarang`;
export const WEDDING_AKAD_DRESSCODE = ENABLE_DRESS_CODE ? `Kebaya dan beskap (Putih)` : '';
export const WEDDING_AKAD_NOTES = `Adat Jawa Solo Muslim`;
export const WEDDING_AKAD_FULLDATE = dayjs(DATE_AKAD)
  .locale(DEFAULT_LANGUAGE)
  .format('dddd, DD MMMM YYYY');

export const WEDDING_RESEPSI_TIME = '11.00 WIB - 13.00 WIB';
export const WEDDING_RESEPSI_LOC_NAME = 'Gets Hotel Semarang';
export const WEDDING_RESEPSI_LOC_ROAD = `Jl. MT. Haryono No.312 - 316, Sarirejo, Kec. Semarang Timur, Kota Semarang`;
export const WEDDING_RESEPSI_DRESSCODE = ENABLE_DRESS_CODE ? `Dress & Jas (Hijau Sage)` : '';
export const WEDDING_RESEPSI_NOTES = `Nasional`;
export const WEDDING_RESEPSI_FULLDATE = dayjs(DATE_RESEPSI)
  .locale(DEFAULT_LANGUAGE)
  .format('dddd, DD MMMM YYYY');
export const WEDDING_RESEPSI_DATE = dayjs(DATE_RESEPSI)
  .locale(DEFAULT_LANGUAGE)
  .format('DD • MMMM • YYYY');

/**
 * ********************************************************
 * Link Generator V2
 * @important - this info will be applied at link generator
 * ********************************************************
 */
export const HOSTNAME = 'https://invitato.net/patraweddingexpo';
export const BROADCAST_WEDDING_LOCATION = `Gets Hotel Semarang`;
export const BROADCAST_WEDDING_DAY = {
  id: dayjs(DATE_RESEPSI).locale('id').format('dddd, DD MMMM YYYY'),
  en: dayjs(DATE_RESEPSI).locale('en').format('dddd, DD MMMM YYYY'),
};

/**
 * ************************************************
 * Maps Location
 * ************************************************
 */
export const GOOGLE_MAPS_AKAD = `https://g.page/getshotelsrg?share`;
export const GOOGLE_MAPS_RESEPSI = `https://g.page/getshotelsrg?share`;

/**
 * ************************************************
 * Backsound Copyright
 * ************************************************
 */
export const SOUND_BY = `Soegi Bornean - Asmalibrasi`;
export const SOUND_URL = 'https://youtu.be/cQGfLDnmWS8';

/**
 * ************************************************
 *  Youtube Live requirement
 * ************************************************
 */
export const YOUTUBE_LINK = 'https://youtu.be/gp9uomY7k-Q';
export const YOUTUBE_EMBED = 'https://www.youtube.com/embed/gp9uomY7k-Q';

/**
 * ************************************************
 *  RSVP & Wishlish Section
 * ************************************************
 */
export const API_HOSTNAME = `https://script.google.com/macros/s/AKfycbxs_ACP7K10WYKT7xKmcoRAUqS5trq7r1f_EK9k4ARkVPLYpvsdGfZeMilb5KHuaW7C/exec`;
export const API_TABLE_NAME = 'wishlist';
export const API_RSVP_TABLE = 'rsvp';
export const SHEET_GIFT_CONFIRMATION = 'gift_confirmation';

/**
 * ************************************************
 *  Invitato Link Requirement
 * ************************************************
 */
export const INVITATO_URL = 'https://invitato.id';
export const INVITATO_IG_URL = 'https://www.instagram.com/invitato.id/';
export const URL_WA_INVITATO =
  'https://wa.me/+628112778189?text=Hi%20Kak,%20aku%20mau%20pesan%20undangan%20online%20nih!';
